export default __webpack_public_path__ + "static/media/upload-prescription.7217da50.svg";